module.exports = __webpack_public_path__ + "static/media/earring-gray.956069dc.svg";